// CANONICAL COPY (GH #7115). src/constants/obligations/obl-incident-response-plan.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-incident-response-plan',
  title: 'Verify incident response plan exists',
  description:
    'Confirm that an incident response plan is published, defines roles and responsibilities, and has been communicated to relevant personnel. The plan shall cover event assessment and classification, containment, eradication, recovery and communication steps.',
  category: 'incidents',
  scfIds: ['SCF-INC-001', 'SCF-INC-002', 'SCF-INC-003'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Incident response plan is published' },
    { type: 'document-approved', description: 'Plan has been approved' },
    { type: 'document-acknowledged', description: 'Key personnel have acknowledged the plan' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
